import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Page;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
export var Page = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Page = /*#__PURE__*/function (_Component) {
  function Page() {
    _classCallCheck(this, Page);
    return _callSuper(this, Page, arguments);
  }
  _inherits(Page, _Component);
  return _createClass(Page, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "shouldRenderSidebar",
    value: function shouldRenderSidebar() {
      return this.props.sidebarComponent != null && this.props.sidebarOpen != null;
    }
  }, {
    key: "renderSidebar",
    value: function renderSidebar() {
      return jsx(this.props.sidebarComponent, {
        role: this.props.sidebarRole,
        sidebarOpen: this.props.sidebarOpen,
        toggleSidebar: this.props.toggleSidebar
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.wrapper
      }, this.shouldRenderSidebar() ? this.renderSidebar() : null, jsx("div", {
        // this component is focusable for SkipToContent
        tabIndex: "-1",
        ref: this.props.childrenWrapperRef,
        role: this.props.contentRole,
        css: this.props.styles.childrenWrapper,
        "aria-label": t('Quiz content')
      }, this.props.children));
    }
  }]);
}(Component), _defineProperty(_Page, "displayName", 'Page'), _defineProperty(_Page, "componentId", "Quizzes".concat(_Page.displayName)), _defineProperty(_Page, "propTypes", {
  children: PropTypes.node.isRequired,
  childrenWrapperRef: PropTypes.func,
  contentRole: PropTypes.string,
  sidebarComponent: PropTypes.func,
  sidebarOpen: PropTypes.bool,
  sidebarRole: PropTypes.string,
  toggleSidebar: PropTypes.func,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_Page, "defaultProps", {
  childrenWrapperRef: function childrenWrapperRef() {},
  contentRole: 'region',
  sidebarComponent: null,
  sidebarOpen: null,
  sidebarRole: 'navigation',
  toggleSidebar: function toggleSidebar() {}
}), _Page)) || _class);
export default Page;